import { JSX } from 'react';
import { Link } from '@mui/material';

interface LogoProps {
  isLink?: boolean;
}

const Logo = ({ isLink = true }: LogoProps): JSX.Element => {
  const logo = <img width={36} height={36} src="/images/m-logo.svg" alt="Logo" />;
  if (isLink) {
    return <Link href="/">{logo}</Link>;
  }

  return logo;
};

export default Logo;
